<template>
	<div class="editor">
		<editor-floating-menu :editor="editor" v-slot="{ commands, isActive, menu, focused, getMarkAttrs }">
				<div class="editor__floating-menu" :class="{ 'is-active': menu.isActive || focused }">

					<v-toolbar dense ccollapse>

						<v-menu offset-y>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									text
									small
									v-bind="attrs"
									v-on="on"
								>
									<span v-if="isActive.paragraph()">Texto normal</span>
									<span v-else-if="isActive.heading({ level: 1 })">Título 1</span>
									<span v-else-if="isActive.heading({ level: 2 })">Título 2</span>
									<span v-else-if="isActive.heading({ level: 3 })">Título 3</span>
									<span v-else>-</span>
								</v-btn>
							</template>
							<v-list>
								<v-list-item @click="commands.paragraph">
									<v-list-item-title>Texto normal</v-list-item-title>
								</v-list-item>
								<v-list-item @click="commands.heading({ level: 1 })">
									<v-list-item-title><h1>Título 1</h1></v-list-item-title>
								</v-list-item>
								<v-list-item @click="commands.heading({ level: 2 })">
									<v-list-item-title><h2>Título 2</h2></v-list-item-title>
								</v-list-item>
								<v-list-item @click="commands.heading({ level: 3 })">
									<v-list-item-title><h3>Título 3</h3></v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>

						<v-divider vertical></v-divider>

						<v-btn icon title="Negritas" @click="commands.bold" :color="isActive.bold() ? 'blue': ''">
							<v-icon>mdi-format-bold</v-icon>
						</v-btn>

						<v-btn icon title="Cursiva" @click="commands.italic" :color="isActive.italic() ? 'blue': ''">
							<v-icon>mdi-format-italic</v-icon>
						</v-btn>

						<v-btn icon title="Subrayar" @click="commands.underline" :color="isActive.underline() ? 'blue': ''">
							<v-icon>mdi-format-underline</v-icon>
						</v-btn>

						<v-divider vertical></v-divider>

						<v-menu offset-y :close-on-content-click="false" v-model="enlace.activo">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									title="Enlace"
									cccccclick="abrirEnlace(getMarkAttrs('link'))"
									ccccolor="isActive.link() ? 'blue': ''"
									v-bind="attrs"
									v-on="on"
									 @click="abrirOpcionesEnlace(getMarkAttrs('link'))"
								>
									<v-icon>mdi-link</v-icon>
								</v-btn>
							</template>
							<v-card>
								<v-card-text>
									<v-text-field
										v-model="enlace.url"
										append-icon="mdi-close"
										append-outer-icon="mdi-check"
										@click:append="establecerEnlace(commands.link, null)"
										@click:append-outer="establecerEnlace(commands.link, enlace.url)"
										label="Enlace"
										placeholder="http://"
										outlined
										dense
										ref="cajaEnlace"
									></v-text-field>
								</v-card-text>
							</v-card>
						</v-menu>

						<v-divider vertical></v-divider>

						<v-btn icon title="Alinear a la izquierda" @click="alineación = 'left'" :color="alineación === 'left' ? 'blue': ''">
							<v-icon>mdi-format-align-left</v-icon>
						</v-btn>

						<v-btn icon title="Centrar" @click="alineación = 'center'" :color="alineación === 'center' ? 'blue': ''">
							<v-icon>mdi-format-align-center</v-icon>
						</v-btn>

						<v-btn icon title="Alinear a la derecha" @click="alineación = 'right'" :color="alineación === 'right' ? 'blue': ''">
							<v-icon>mdi-format-align-right</v-icon>
						</v-btn>

						<v-btn icon title="Justificar" @click="alineación = 'justify'" :color="alineación === 'justify' ? 'blue': ''">
							<v-icon>mdi-format-align-justify</v-icon>
						</v-btn>

						<v-divider vertical></v-divider>

						<v-btn
							icon
							v-if="opciones.listaNoOrdenada"
							title="Lista"
							@click="commands.bullet_list"
							:color="isActive.bullet_list() ? 'blue': ''"
						>
							<v-icon>mdi-format-list-bulleted</v-icon>
						</v-btn>

						<v-btn
							icon
							v-if="opciones.listaNumerada"
							title="Lista numerada"
							@click="commands.ordered_list"
							:color="isActive.ordered_list() ? 'blue': ''"
						>
							<v-icon>mdi-format-list-numbered</v-icon>
						</v-btn>

						<v-divider vertical v-if="opciones.listaNoOrdenada && opciones.listaNumerada"></v-divider>

						<v-btn icon title="Deshacer" @click="commands.undo">
							<v-icon>mdi-undo</v-icon>
						</v-btn>

						<v-btn icon title="Rehacer" @click="commands.redo">
							<v-icon>mdi-redo</v-icon>
						</v-btn>

					</v-toolbar>
				</div>
    </editor-floating-menu>
		<editor-content :editor="editor"></editor-content>
	</div>
</template>

<script>


import { Editor, EditorContent, EditorFloatingMenu } from 'tiptap'
import {
  Bold,
  Italic,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  Underline,
	History,
	Link,
	Placeholder,
} from 'tiptap-extensions'

export default {
	name: 'ParteTexto',

	data: () => ({
		editor: null,
		alineación: '',
		enlace: {
			activo: false,
			url: '',
		},
	}),

	props: {
		value: String,
		opciones: {
			type: Object,
			default: function() {
				return {
					listaNoOrdenada: true,
					listaNumerada: true
				}
			}
		}
	},

  mounted() {
    this.editor = new Editor({
			extensions: [
				new HardBreak(),
				new Heading({ levels: [1, 2, 3] }),
				new BulletList(),
				new OrderedList(),
				new ListItem(),
				new Bold(),
				new Italic(),
				new Underline(),
				new History(),
				new Link(),
				new Placeholder({
					emptyEditorClass: 'is-editor-empty',
					emptyNodeClass: 'is-empty',
					emptyNodeText: 'Escribe aquí...',
					showOnlyWhenEditable: true,
					showOnlyCurrent: true,
				}),
			],
			content: this.value,
			onUpdate: ({ getHTML }) => {
				this.$emit('input', getHTML())
			},
		})
	},

  beforeDestroy() {
    this.editor.destroy()
  },

	components: {
		EditorFloatingMenu,
		EditorContent
	},

	watch: {
		value (val) {
			if (this.editor && val !== this.value) {
				this.editor.setContent(val, true)
			}
		},
		'alineación': function(v) {
			this.$emit('alinear', v)
		}
	},

	methods: {
		abrirOpcionesEnlace: function(atrs) {
			this.enlace.url = atrs.href
			//this.enlace.activo = true / redundante con con evento dv-menu
      this.$nextTick(() => {
				setTimeout(() => {
					let ipt = this.$refs.cajaEnlace.$el.querySelector('input[type="text"]')
					if (ipt) {
						ipt.focus()
					}
				}, 300)
			})
		},
    ocultarOpcionesEnlace: function() {
      this.enlace.url = null
      this.enlace.activo = false
		},
		establecerEnlace: function(commandLink, url) {
			commandLink({ href: url })
			this.ocultarOpcionesEnlace()
		}
	}

}

</script>
